import { styled } from '../../../theme/stitches.config';

export const SMPScore = styled('a', {
  // Reset
  boxSizing: 'border-box',
  display: 'flex',
  fontFamily: '$primaryFontFamily',
  fontSize: '$3',
  alignItems: 'center',
  flex: '0.5 1 0',
  gap: '$2',
  textDecoration: 'none',
  outline: 'none',
  cursor: 'pointer',
  mt: '0px',
  variants: {
    padding: {
      top: {
        pt: '$1',
      },
      none: {
        p: '0px',
      },
    },
    direction: {
      row: {
        fd: 'row',
      },
      column: {
        fd: 'column',
      },
      rowReverse: {
        fd: 'row-reverse',
      },
      columnReverse: {
        fd: 'column-reverse',
      },
    },
    variant: {
      horizontal: {
        fd: 'row',
        textAlign: 'left',
      },
      vertical: {
        flex: '0.5 1 0',
        fd: 'column',
        textAlign: 'center',
        gap: '$2',
        mt: '10px',
      },
      responsive: {
        flex: '1 1 0',
        fd: 'column',
        textAlign: 'center',
        gap: '$3',
        mt: '0',
      },
    },
  },
});
